import { GzHeaderController } from '../controller/GzHeaderController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { Theme } from 'libs/shared/color-theme/src/lib/types';

export class GzHeaderWebComponent extends BaseWebComponentElement {
  public controller!: GzHeaderController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GzHeaderController,
    });
  }

  public updateNewNotificationsCount(count: number): void {
    this.controller.updatNotificationsBadgeContent(count);
  }

  public updateDarkTheme(): void {
    // if OS theme is set to dark/light we use when auto is selected
    this.controller.getSavedTheme().then(darkModeState => {
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const theme = systemPrefersDark ? Theme.DARK : Theme.LIGHT;
      if (darkModeState === Theme.AUTO) {
        document.documentElement.setAttribute('theme', theme);
        localStorage.setItem('theme', theme);
      } else {
        document.documentElement.setAttribute('theme', darkModeState);
        localStorage.setItem('theme', darkModeState);
      }
    }).catch(
      () => {
        document.documentElement.setAttribute('theme', Theme.AUTO);
        localStorage.setItem('theme', Theme.AUTO);
      }
    );
  }

  public setMenuItemVisibility(itemId: string, isVisible: boolean): void {
    this.controller.setMenuItemVisibility(itemId, isVisible);
  }

  public setMenuItemActive(id: string, isActive: boolean): void {
    this.controller.setMenuItemActive(id, isActive);
  }

  public clearActive(): void {
    this.controller.clearActive();
  }

  public getMenuItemElement(id: string): HTMLElement | undefined {
    return this.controller.getMenuItem(id);
  }

  public setUserFeaturesAndRights(isCloud?: boolean): void {
    this.controller.setUserFeaturesAndRights(isCloud);
  }

  public setContentOverlayLoadingState(state: boolean): void {
    this.controller.setOverlayContentLoadingState(state);
  }
}
